import { useEffect, useState } from "react";

/**
 * Retorna `value` após `delay` ms sem novas alterações.
 * Útil para busca sem disparar requisições a cada tecla.
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
